<template>
<div class="informdetail" name="informdetail">
  <!-- <topNav :title="title"></topNav> -->


</div>

</template>
<script>
// import topNav from "../topnav/topnav"
export default {
  name: 'indetail',
  components:{
    //  topNav,
  },
  data() {
    return {
      // title:"账单详情"
    }
  },
  methods:{
  },
  created(){
  //   var loadinginstace=this.$toast.loading({
  //       mask: true,
  //       message: '加载中...'
  //       });
  //  var carNumUrl=this.commonUtil.getUrlKey("carNum");
  //  this.commonUtil.setCookie("carNum",carNumUrl,30);
  //  var carNum = this.commonUtil.getCookie("carNum");
  //  alert(location.href)
  //  alert("1111"+carNumUrl)
  //  if(!this.commonUtil.isEmpty(carNum))
  //  {
  //     this.commonUtil.queryajax(carNum,'indetail');
  //  }
  },
  mounted(){
    if(this.commonUtil.browserType() == "wx"){
      var loadinginstace=this.$toast.loading({
        mask: true,
        message: '加载中...'
        });
        let originalId = sessionStorage.getItem("originalId");
        var carNum = sessionStorage.getItem("carNum");
        if(originalId){
            this.commonUtil.indetailquery(carNum);
        }
    }
  },

    watch:{
    "$route":{
      handler(){
        if(this.commonUtil.browserType() == "al"){
          var loadinginstace=this.$toast.loading({
          mask: true,
          message: '加载中...'
          });
          let originalId = sessionStorage.getItem("originalId");
          var carNum = sessionStorage.getItem("carNum");
          if(originalId){
              this.commonUtil.indetailquery(carNum);
          }

        }
      },
      immediate:true
    }
  }

}
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/components/paydetail/indetail.vue